import { render } from "./OrderPage.vue?vue&type=template&id=b095bf3a"
import script from "./OrderPage.vue?vue&type=script&lang=js"
export * from "./OrderPage.vue?vue&type=script&lang=js"
script.render = render

export default script